<template>
  <v-container class="backup">
 <v-layout class="searchsecond">
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          background-color="grey"
          loading
          flat
          label="search the discussion"
          solo-inverted
          style="max-width: 350px;"
        />
</v-layout>
    <v-layout row wrap v-for="meetup in filtermeetups" :key="meetup.id" class="mb-2">
      <v-flex xs12 sm10 md8 offset-sm1 offset-md2>
        <v-card width="100%" height="90%">
          <v-img src="">
          <v-container fluid>
            <v-layout row>
              <v-flex xs5 sm4 md3>
                <v-img
                  :src="meetup.imageUrl"
                  height="80%"
                ></v-img>
              </v-flex>
              <v-flex xs7 sm8 md9>
                <v-card-title primary-title>
                  <div class="texttitle">
                    <h5 class="black--text mb-3" >{{ meetup.title | toUpCase }}</h5>
                    <div>{{ meetup.date | date }}</div>
                  </div>
                </v-card-title>
               
                  <v-btn flat :to="'/meetups/' + meetup.id" type="primary" class="outcard">
                   <i class="el-icon-s-promotion"></i>
                    View Details
                  </v-btn>
      
              </v-flex>
            </v-layout>
          </v-container>
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
 data(){
          return {
            search:'',
            loadedMeetups:[]
          }
      },
    computed: {
      filtermeetups () {
        return this.$store.getters.loadedMeetups.filter((meetup)=>{
            if (meetup.title.match(this.search.toLowerCase())) {      //博客标题匹配
              return meetup.title.match(this.search.toLowerCase());   //返回标题匹配的一个博客数组
            }
          })
        
      },
    
    },
    filters:{
        toUpCase(value){
          let strArr = value.toUpperCase().split(' ');
          for (let i=0,len=strArr.length; i<len; i++){
            strArr[i] = strArr[i].charAt(0)+strArr[i].slice(1).toLowerCase();
          }
          return strArr.join(' ');
        },
      }
     
  }
</script>





















<style>
.backup{
height: 100%;
}
.texttitle{
font-size: 30px;
}
.outcard{
margin-bottom: 50px;
background-color: rgba(66, 149, 245, 0.774);

}
.searchsecond{
margin-bottom: 0px;
margin-left: 32%;
margin-right: 25%;


}
</style>